import { GenericInfoIcon, GreenCheckMarkIcon } from 'assets/icons';
import CloseIcon from 'assets/images/actions/closeIcon.svg?react';
import './styles.scss';

interface Props {
	type: string;
	title: string;
	desc: string;
	onClose?: () => void;
	className?: string;
	cyTestRef?: string;
	cyDescriptionTestRef?: string;
}

export const Warning: React.FC<Props> = ({ type, title, desc, className, onClose, cyTestRef }: Props) => (
	<div className={`warning warning--${type} ${className ? className : ''}`}>
		{type === 'success' ? (
			<GreenCheckMarkIcon className={`warning__icon warning__icon--${type}`} />
		) : (
			<GenericInfoIcon className={`warning__icon warning__icon--${type}`} />
		)}

		<div className="warning__text">
			<p className="warning__text__title">{title}</p>
			<p className="warning__text__description" dangerouslySetInnerHTML={{ __html: desc }} data-cy={cyTestRef} />
		</div>
		{onClose && (
			<div className="warning__close">
				<CloseIcon onClick={onClose} />
			</div>
		)}
	</div>
);

export default Warning;
